/* Krishna Furniture — about page behaviour.
   Reveals, blueprint draw-on, counters, pointer tilt/glare, and the pinned 3D stage.
   One rAF drives everything that is scroll- or pointer-linked; nothing else polls. */

(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch=window.matchMedia('(hover: none)').matches;
  var innerH=window.innerHeight;
  window.addEventListener('resize',function(){innerH=window.innerHeight;});
  function lerp(a,b,t){return a+(b-a)*t;}
  function clamp(v,a,b){return v<a?a:(v>b?b:v);}

  /* ---- reveal on enter ------------------------------------------------
     IntersectionObserver drives this, with a geometric sweep standing behind it.
     The sweep is not belt-and-braces. An element that is itself clipped reports a
     zero intersection to the observer, and the display headings start life wiped
     out by clip-path — so the observer would never tell them to un-clip, and the
     reveal deadlocked on its own start state. The hero heading rendered as blank
     space because of exactly that. The sweep decides from the element's own box,
     which no clip can take away. Each element leaves the list once it is in. */
  var rvPending=[];
  (function(){
    var els=[].slice.call(document.querySelectorAll('.rv,.stg'));
    if(reduce){els.forEach(function(e){e.classList.add('in');});return;}
    rvPending=els;
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -6% 0px'});
      els.forEach(function(e){io.observe(e);});
    }
  })();
  function rvSweep(){
    if(!rvPending.length) return;
    var keep=[];
    for(var i=0;i<rvPending.length;i++){
      var el=rvPending[i];
      if(el.classList.contains('in')) continue;
      var r=el.getBoundingClientRect();
      if(r.top<innerH*0.94 && r.bottom>0) el.classList.add('in'); else keep.push(el);
    }
    rvPending=keep;
  }

  /* ---- blueprint draws itself in ----------------------------------------
     The page opens by claiming every piece is drawn before it is built, so the
     elevation should arrive as a drawing in progress rather than a finished
     graphic. Each path is dashed to its own length and the offset is released
     in order, longest structural lines first. Lengths are measured once. */
  (function(){
    var bp=document.querySelector('.hero-figure .blueprint');
    if(!bp||reduce) return;
    var paths=[].slice.call(bp.querySelectorAll('path'));
    var ok=[];
    paths.forEach(function(p){
      var len=0;
      try{ len=p.getTotalLength(); }catch(e){ return; }
      if(!len||!isFinite(len)) return;
      p.style.strokeDasharray=len+' '+len;
      p.style.strokeDashoffset=len;
      ok.push(p);
    });
    if(!ok.length) return;
    bp.classList.add('drawing');
    function run(){
      ok.forEach(function(p,i){
        p.style.transition='stroke-dashoffset 1.15s cubic-bezier(.2,.7,.2,1) '+(0.18+i*0.045)+'s';
        p.style.strokeDashoffset='0';
      });
      // Once drawn, drop the dash so nothing shimmers on later repaints.
      setTimeout(function(){ ok.forEach(function(p){p.style.strokeDasharray='';p.style.transition='';}); bp.classList.remove('drawing'); bp.classList.add('drawn'); },
        1400+ok.length*45);
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ io.disconnect(); run(); } },{threshold:.2});
      io.observe(bp);
    } else run();
  })();

  /* ---- counters ----------------------------------------------------------
     The numbers on this page are the argument, so they should land rather than
     just appear. The label is split into prefix / digits / suffix so "5 Lakh+"
     and "1,000+" both count and keep their wording. Years roll from a short run
     up instead of from zero — a year ticking from 0 reads as a loading bar. */
  (function(){
    if(reduce||!('IntersectionObserver' in window)) return;
    var nodes=[].slice.call(document.querySelectorAll('.stat-n,.spec-n,.team-n'));
    var live=[];
    nodes.forEach(function(el){
      var m=/^([^\d]*)([\d][\d,]*)(.*)$/.exec(el.textContent.trim());
      if(!m) return;
      var raw=m[2], val=parseInt(raw.replace(/,/g,''),10);
      if(!isFinite(val)) return;
      var grouped=raw.indexOf(',')>-1;
      var year=val>=1900&&val<=2100;
      el.dataset.kfPre=m[1]; el.dataset.kfSuf=m[3];
      el.dataset.kfTo=val; el.dataset.kfFrom=year?Math.max(0,val-28):0;
      el.dataset.kfGroup=grouped?'1':'';
      el.textContent=m[1]+fmt(parseInt(el.dataset.kfFrom,10),grouped)+m[3];
      live.push(el);
    });
    if(!live.length) return;
    function fmt(n,grouped){ return grouped?n.toLocaleString('en-US'):String(n); }
    function run(el){
      var from=parseInt(el.dataset.kfFrom,10), to=parseInt(el.dataset.kfTo,10);
      var grouped=!!el.dataset.kfGroup, pre=el.dataset.kfPre, suf=el.dataset.kfSuf;
      var dur=1250, t0=0;
      function step(ts){
        if(!t0) t0=ts;
        var p=clamp((ts-t0)/dur,0,1);
        var e=1-Math.pow(1-p,3);                       // ease-out cubic: fast, then settles
        el.textContent=pre+fmt(Math.round(from+(to-from)*e),grouped)+suf;
        if(p<1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ io.unobserve(e.target); run(e.target); } });},{threshold:.6});
    live.forEach(function(el){io.observe(el);});
  })();

  /* ---- pointer tilt + glare ----------------------------------------------
     The tilt is CSS-transitioned rather than rAF-damped on purpose: one
     transition per card costs nothing and stays smooth while the 3D stage has
     the frame budget. The glare is a radial highlight parked at the cursor, so
     a card reads as a surface catching light instead of a rectangle. */
  if(!touch&&!reduce){
    document.querySelectorAll('.cap,.leader,.show,.stat,.founder').forEach(function(card){
      // A showroom row is a switch that the map answers, so it gets the glare but not
      // the tilt — a card that leans away under the cursor reads as decoration, not a control.
      var flat=card.classList.contains('stat')||card.classList.contains('founder')||card.classList.contains('show');
      var noGlare=card.classList.contains('stat')||card.classList.contains('founder');
      if(!noGlare){ var g=document.createElement('i'); g.className='glare'; g.setAttribute('aria-hidden','true'); card.appendChild(g); }
      card.addEventListener('mousemove',function(e){
        var r=card.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
        card.style.setProperty('--gx',((px+.5)*100)+'%');
        card.style.setProperty('--gy',((py+.5)*100)+'%');
        if(flat) return;
        card.style.transform='perspective(900px) rotateY('+(px*7)+'deg) rotateX('+(-py*7)+'deg) translateY(-5px) scale(1.012)';
      });
      card.addEventListener('mouseleave',function(){card.style.transform='';});
    });

    /* Magnetic buttons: the pill leans a few pixels toward the cursor, which
       makes it feel picked up rather than hovered. Capped so it never detaches
       from its own hit area. */
    document.querySelectorAll('.kf-page .btn').forEach(function(b){
      b.addEventListener('mousemove',function(e){
        var r=b.getBoundingClientRect();
        var dx=clamp((e.clientX-r.left-r.width/2)/r.width*18,-7,7);
        var dy=clamp((e.clientY-r.top-r.height/2)/r.height*14,-5,5);
        b.style.transform='translate('+dx+'px,'+(dy-2)+'px)';
      });
      b.addEventListener('mouseleave',function(){b.style.transform='';});
    });
  }

  /* ---- hero mouse-tilt ---- */
  var hero=document.querySelector('.hero'), bp=document.querySelector('.hero-figure .blueprint');
  var heroTX=0,heroTY=0,heroX=0,heroY=0,heroLive=false;
  if(hero&&bp&&!touch&&!reduce){
    hero.addEventListener('mousemove',function(e){
      var r=hero.getBoundingClientRect();
      heroTX=(e.clientX-r.left)/r.width-.5; heroTY=(e.clientY-r.top)/r.height-.5; heroLive=true;
    });
    hero.addEventListener('mouseleave',function(){heroTX=0;heroTY=0;});
  }

  /* ---- refs for parallax + pin ---- */
  var heroCopy=document.querySelector('.hero-copy');
  var statsEl=document.querySelector('.stats');
  var statsSec=statsEl?statsEl.closest('section'):null;
  var statsVis=false;
  if(statsSec&&'IntersectionObserver' in window){ new IntersectionObserver(function(es){statsVis=es[0].isIntersecting;}).observe(statsSec); } else { statsVis=true; }

  /* The timeline's spine draws down as the section passes, so the list reads as
     one continuous thread rather than five separate rows. */
  var tl=document.querySelector('.tl'), tlVis=false;
  if(tl&&'IntersectionObserver' in window){ new IntersectionObserver(function(es){tlVis=es[0].isIntersecting;}).observe(tl); } else tlVis=true;

  /* ---- pinned scrub : the 3D stage ---- */
  var pin=document.getElementById('pin'), sticky=pin&&pin.querySelector('.pin-sticky');
  var canvas=document.getElementById('stagecv'), fb=document.getElementById('pinfb');
  var stepsEl=[].slice.call(document.querySelectorAll('#pinsteps .step'));
  var prog=document.getElementById('pinprog'), mcap=document.getElementById('pincap');
  /* Each step names its own stage. The captions used to live here, which meant the
     one thing on the panel that could not be edited in Customize was the line
     describing what you were looking at. They come off the blocks now, and the old
     list stays only as a fallback for a step that has not been given one. */
  var capFallback=['KING BED · DRAWING','FRAME · SOLID PINE','UPHOLSTERY · YOUR FABRIC','FINISH · BRASS & BEDDING','DELIVERED · YOUR HOME'];
  var caps=[];
  var pinReady=false, pinVis=false, theta=-0.92,tTheta=-0.92, radius=7.4,tRadius=7.4, phi=1.35,tPhi=1.35, cur=-1, renderer,scene,camera,chairGrp;
  var hasVideo=!!document.querySelector('.pin-media.has-video');

  /* Pointer orbit. The scroll owns the sweep; the mouse adds a small offset on
     top of it, so the piece answers the cursor without ever losing the angle the
     scroll position asked for. Values are damped in the frame loop, not here. */
  var mOrbX=0,mOrbY=0,mTgtX=0,mTgtY=0;
  if(sticky&&!touch&&!reduce){
    sticky.addEventListener('mousemove',function(e){
      var r=sticky.getBoundingClientRect();
      mTgtX=clamp((e.clientX-r.left)/r.width-.5,-.5,.5);
      mTgtY=clamp((e.clientY-r.top)/r.height-.5,-.5,.5);
    });
    sticky.addEventListener('mouseleave',function(){mTgtX=0;mTgtY=0;});
  }

  /* Highlighting the step and naming the stage is about the copy, not the 3D, so it
     lives out here and runs whether or not buildStage() ever got going. With a film in
     the panel the caption is whatever was typed in Customize, so it is left alone. */
  caps=stepsEl.map(function(s,k){ return (s.getAttribute('data-cap')||'').trim() || capFallback[k] || capFallback[0]; });

  function setStep(i){
    stepsEl.forEach(function(s,k){ s.classList.toggle('active', k===i); });
    if(mcap && !hasVideo) mcap.textContent=caps[i]||caps[0];
  }

  function buildStage(){
    renderer=new THREE.WebGLRenderer({canvas:canvas,antialias:true,alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    renderer.outputEncoding=THREE.sRGBEncoding;
    renderer.toneMapping=THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure=1.0;
    renderer.shadowMap.enabled=true;
    renderer.shadowMap.type=THREE.PCFSoftShadowMap;

    scene=new THREE.Scene();
    camera=new THREE.PerspectiveCamera(30,1,0.1,100);

    /* ---------------------------------------------------------------
       The piece is a real model now: kf-about-bed.glb, the upholstered king bed
       from our own workshop, built in five named layers that match the five
       steps — Draft (line work), Frame + Slats (pine carcass), Upholstery,
       Trim + Bedding (brass and the made bed), Room (nightstands, lamps, rug).
       The file only carries geometry and colour maps; the light, the floor
       shadow and the reflections are set up here so it sits in the same studio
       the chair used to.
       --------------------------------------------------------------- */
    function canvasTex(w,h,draw){
      var c=document.createElement('canvas'); c.width=w; c.height=h;
      draw(c.getContext('2d'),w,h);
      return new THREE.CanvasTexture(c);
    }

    /* A studio in a texture: a warm softbox high and left, a second lower and
       right, a floor bounce below. This is what the brass and the leather
       actually reflect, so it does more for realism than any extra lamp. */
    var envTex=canvasTex(256,128,function(x,w,h){
      var g=x.createLinearGradient(0,0,0,h);
      g.addColorStop(0,'#fff6e6'); g.addColorStop(.30,'#e6d3b2');
      g.addColorStop(.50,'#75624c'); g.addColorStop(.72,'#33271c'); g.addColorStop(1,'#120e09');
      x.fillStyle=g; x.fillRect(0,0,w,h);
      function box(cx,cy,rx,ry,a){
        var rg=x.createRadialGradient(cx,cy,0,cx,cy,Math.max(rx,ry));
        rg.addColorStop(0,'rgba(255,250,238,'+a+')'); rg.addColorStop(1,'rgba(255,250,238,0)');
        x.fillStyle=rg; x.beginPath(); x.ellipse(cx,cy,rx,ry,0,0,Math.PI*2); x.fill();
      }
      box(w*0.28,h*0.20,w*0.15,h*0.20,1);            // key softbox
      box(w*0.72,h*0.26,w*0.10,h*0.14,.55);          // secondary
      box(w*0.50,h*0.96,w*0.55,h*0.12,.22);          // floor bounce
    });
    envTex.mapping=THREE.EquirectangularReflectionMapping;
    var pmrem=new THREE.PMREMGenerator(renderer);
    scene.environment=pmrem.fromEquirectangular(envTex).texture;
    pmrem.dispose();

    var FLOOR=-.79, SCALE=1.02;
    var floor=new THREE.Mesh(new THREE.PlaneGeometry(24,24),new THREE.ShadowMaterial({opacity:.36}));
    floor.rotation.x=-Math.PI/2; floor.position.y=FLOOR; floor.receiveShadow=true;
    scene.add(floor);

    /* A shadow map alone leaves a gap of light where the feet meet the floor.
       This is the contact darkening that sells the piece as standing on something. */
    var aoTex=canvasTex(256,256,function(x,w,h){
      var g=x.createRadialGradient(w/2,h/2,0,w/2,h/2,w/2);
      g.addColorStop(0,'rgba(0,0,0,.55)'); g.addColorStop(.45,'rgba(0,0,0,.28)');
      g.addColorStop(.75,'rgba(0,0,0,.08)'); g.addColorStop(1,'rgba(0,0,0,0)');
      x.fillStyle=g; x.fillRect(0,0,w,h);
    });
    var aoMat=new THREE.MeshBasicMaterial({map:aoTex,transparent:true,depthWrite:false,opacity:0});
    var ao=new THREE.Mesh(new THREE.PlaneGeometry(2.9*SCALE,2.7*SCALE),aoMat);
    ao.rotation.x=-Math.PI/2; ao.position.set(0,FLOOR+.004,.06*SCALE);
    scene.add(ao);

    // --- lighting: key / fill / rim, warm above and cool from below ---
    scene.add(new THREE.HemisphereLight(0xfff1dc,0x241a12,.40));
    var key=new THREE.DirectionalLight(0xfff0d8,1.30);
    key.position.set(4.2,7.4,4.6);
    key.castShadow=true;
    key.shadow.mapSize.set(2048,2048);
    key.shadow.camera.near=1; key.shadow.camera.far=22;
    key.shadow.camera.left=-4; key.shadow.camera.right=4;
    key.shadow.camera.top=4; key.shadow.camera.bottom=-4;
    key.shadow.bias=-0.0006; key.shadow.normalBias=.02; key.shadow.radius=4;
    scene.add(key);
    var fill=new THREE.DirectionalLight(0xbfd0e6,.34); fill.position.set(-5.5,2.4,3.2); scene.add(fill);
    var rim=new THREE.DirectionalLight(0xffd9a0,.80); rim.position.set(-2.6,3.4,-6.2); scene.add(rim);
    var raker=new THREE.PointLight(0xffe7c2,.45,14,2); raker.position.set(2.0,1.8,2.6); scene.add(raker);

    /* ---------------------------------------------------------------
       Stage choreography. Each scroll step is a real step in how the bed is made:
         01 drawn       -> line work only
         02 framed      -> pine carcass and slats, as on the workshop floor
         03 upholstered -> the leatherette shell closes over the frame
         04 finished    -> brass trim goes on, the bed is made
         05 delivered   -> nightstands, lamps and the rug: it is in a room
       Layers fade, and the soft ones also settle into place from just above.
       --------------------------------------------------------------- */
    var LAYERS=['Draft','Frame','Slats','Upholstery','Trim','Bedding','Room'];
    var STAGES=[
      {Draft:1,  Frame:0,Slats:0,Upholstery:0,Trim:0,Bedding:0,Room:0,ground:0},
      {Draft:.30,Frame:1,Slats:1,Upholstery:0,Trim:0,Bedding:0,Room:0,ground:1},
      {Draft:0,  Frame:0,Slats:1,Upholstery:1,Trim:0,Bedding:0,Room:0,ground:1},
      {Draft:0,  Frame:0,Slats:0,Upholstery:1,Trim:1,Bedding:1,Room:0,ground:1},
      {Draft:0,  Frame:0,Slats:0,Upholstery:1,Trim:1,Bedding:1,Room:1,ground:1}
    ];
    var DROP={Upholstery:.10,Bedding:.22,Room:.0,Trim:.04};
    var target={}, cur3={}, layer={};
    for(var k0 in STAGES[0]){ target[k0]=STAGES[0][k0]; cur3[k0]=STAGES[0][k0]; }

    var bed=new THREE.Group(); bed.position.y=FLOOR; bed.scale.setScalar(SCALE);
    chairGrp=bed; scene.add(bed);

    function tickStage(){
      var k=.085;
      for(var key2 in target) cur3[key2]=lerp(cur3[key2],target[key2],k);
      aoMat.opacity=cur3.ground*.8;
      LAYERS.forEach(function(n){
        var L=layer[n]; if(!L) return;
        var o=cur3[n]*(n==='Draft'?.9:1);
        L.node.visible=o>.004;
        L.mats.forEach(function(m){
          m.opacity=o;
          // Solid once it has arrived, so it sorts and shadows like a normal surface.
          var solid=o>.995; m.transparent=!solid; m.depthWrite=solid||n==='Draft'?true:o>.6;
        });
        L.meshes.forEach(function(m){ m.castShadow=o>.5; });
        if(DROP[n]) L.node.position.y=(1-cur3[n])*DROP[n];
      });
    }

    var glbUrl=canvas.getAttribute('data-glb');
    if(!glbUrl||!THREE.GLTFLoader) throw new Error('no model');
    new THREE.GLTFLoader().load(glbUrl,function(gltf){
      var root=gltf.scene.getObjectByName('KrishnaKingBed')||gltf.scene;
      root.children.slice().forEach(function(node){
        var L={node:node,mats:[],meshes:[]};
        node.traverse(function(o){
          if(!o.material) return;
          var m=o.material;
          if(o.isMesh){
            o.castShadow=true; o.receiveShadow=true; L.meshes.push(o);
            if(m.map){ m.map.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy()); }
            m.envMapIntensity=m.metalness>.5?1.0:.45;
          }
          if(L.mats.indexOf(m)<0) L.mats.push(m);
        });
        layer[node.name]=L;
      });
      // Draft lines are drawn in the brass of the hero drawing, over everything else.
      if(layer.Draft) layer.Draft.mats.forEach(function(m){ m.color.set(0xc9a56a); m.transparent=true; });
      bed.add(gltf.scene);
      tickStage();
    },undefined,function(){ fb.classList.add('on'); canvas.style.display='none'; });

    // The outer rAF already calls renderer.render every frame while the section is
    // on screen — piggyback on it instead of starting a second loop.
    var _render=renderer.render.bind(renderer);
    renderer.render=function(sc,cm){ tickStage(); _render(sc,cm); };

    window.__setStage=function(i){
      var st=STAGES[Math.max(0,Math.min(STAGES.length-1,i))];
      for(var k2 in st) target[k2]=st[k2];
      setStep(i);
    };

    window.__setStage(0);
    resizePin();
  }

  /* The bed with its nightstands is wider than it is tall, so a narrow canvas (the
     phone layout puts it above the copy) pulls the camera back until it fits. */
  var fitK=1;
  function resizePin(){ if(!renderer)return; var w=canvas.clientWidth,h=canvas.clientHeight; renderer.setSize(w,h,false); camera.aspect=w/h; camera.updateProjectionMatrix(); fitK=clamp(2.0/camera.aspect,1,2.8); }
  function placePin(){
    var ph=clamp(phi,0.95,1.62);
    var r=radius*fitK, x=r*Math.sin(ph)*Math.sin(theta),y=r*Math.cos(ph),z=r*Math.sin(ph)*Math.cos(theta);
    camera.position.set(x,y,z); camera.lookAt(0,-.06,-.22);   /* the visual centre of the bed: low, and back towards the headboard that carries the mass */
  }
  function pinProgress(){ var t=pin.offsetHeight-sticky.offsetHeight; if(t<=0)return 0; return Math.max(0,Math.min(1,-pin.getBoundingClientRect().top/t)); }

  if(pin&&canvas){
    if(typeof THREE==='undefined'){ fb.classList.add('on'); canvas.style.display='none'; }
    else{
      try{ buildStage(); pinReady=true; if(reduce&&window.__setStage) window.__setStage(0); }
      catch(e){ fb.classList.add('on'); canvas.style.display='none'; }
      if('IntersectionObserver' in window){ new IntersectionObserver(function(es){pinVis=es[0].isIntersecting;}).observe(pin); } else pinVis=true;
      window.addEventListener('resize',resizePin);
    }
  }

  /* ---- build photos: the scroll scrubs five real stills ----------------------
     Each still holds a stretch of the scroll and dissolves into the next across a
     short window, so dragging the page back and forth plays the build like a film.
     A camera curve runs over the top: it opens tight on the drawing pinned to the
     workshop wall (top right of the first photo), pulls back to the frame, then
     pushes in gently through the rest. The pointer adds a perspective tilt and a
     counter-shift of the image, and a soft highlight follows it: that is what turns
     flat photos into something that feels like it has depth. */
  var seq=document.getElementById('pinseq'), seqCam=seq&&seq.querySelector('.pin-seq-cam');
  var seqImgs=seq?[].slice.call(seq.querySelectorAll('.pin-seq-img')):[];
  // [start, end] of the scroll each still owns; dissolves are centred on each boundary.
  var SEQ_HOLD=[[0,.40],[.40,.52],[.52,.62],[.62,.80],[.80,1]], SEQ_FADE=.045;
  // camera keys: [progress, zoom, focus x, focus y]
  var SEQ_CAM=[[0,2.3,.83,.15],[.035,2.3,.83,.15],[.18,1.0,.5,.5],[.40,1.12,.46,.58],[.46,1.04,.5,.55],[.62,1.0,.5,.5],[.80,1.10,.5,.6],[.86,1.03,.5,.55],[1,1.0,.5,.5]];
  var seqP=-1, seqMX=0, seqMY=0;
  function smooth(t){ return t*t*(3-2*t); }
  function seqCamAt(p){
    for(var i=1;i<SEQ_CAM.length;i++){
      var a=SEQ_CAM[i-1], b=SEQ_CAM[i];
      if(p<=b[0]){ var t=smooth(clamp((p-a[0])/((b[0]-a[0])||1),0,1)); return [lerp(a[1],b[1],t),lerp(a[2],b[2],t),lerp(a[3],b[3],t)]; }
    }
    var l=SEQ_CAM[SEQ_CAM.length-1]; return [l[1],l[2],l[3]];
  }
  function seqWeight(k,p){
    var h=SEQ_HOLD[k]; if(!h) return 0;
    var a=k===0?1:smooth(clamp((p-(h[0]-SEQ_FADE))/(2*SEQ_FADE),0,1));
    var b=k===SEQ_HOLD.length-1?1:1-smooth(clamp((p-(h[1]-SEQ_FADE))/(2*SEQ_FADE),0,1));
    return Math.min(a,b);
  }
  function drawSeq(p){
    if(seqP<0) seqP=p;
    seqP+=(p-seqP)*(reduce?1:.12);        // the film eases to where the scroll is
    seqMX=lerp(seqMX,mTgtX,.07); seqMY=lerp(seqMY,mTgtY,.07);
    var c=seqCamAt(seqP), z=c[0];
    seqImgs.forEach(function(im,k){
      var w=seqWeight(k,seqP);
      im.style.opacity=w.toFixed(3);
      if(w>0.001){
        /* Scale about the centre, then slide so the focus point sits mid-frame —
           clamped so the photo's own edge never comes into view. */
        var zz=z*1.04, lim=(zz-1)/2;
        var tx=clamp(-(c[1]-.5)*zz,-lim,lim)*100, ty=clamp(-(c[2]-.5)*zz,-lim,lim)*100;
        // the image slides against the tilt, a touch more than the frame: cheap depth
        im.style.transform='translate('+tx.toFixed(2)+'%,'+ty.toFixed(2)+'%) translate3d('+(-seqMX*16).toFixed(1)+'px,'+(-seqMY*12).toFixed(1)+'px,0) scale('+zz.toFixed(4)+')';
      }
    });
    var sweep=(seqP-.5)*5;                 // a slow turn across the whole scroll
    seqCam.style.transform='rotateY('+(sweep+seqMX*7).toFixed(2)+'deg) rotateX('+(-seqMY*5).toFixed(2)+'deg)';
    seq.style.setProperty('--gx',(30+seqMX*60).toFixed(1)+'%');
    seq.style.setProperty('--gy',(20+seqMY*50).toFixed(1)+'%');
  }

  /* ---- single rAF: parallax + pointer + pin ---- */
  var rvTick=0;
  function frame(ts){
    requestAnimationFrame(frame);
    if((rvTick=(rvTick+1)%6)===0) rvSweep();
    if(!reduce){
      if(heroCopy&&hero){ var hr=hero.getBoundingClientRect(); if(hr.bottom>0&&hr.top<innerH){ heroCopy.style.transform='translateY('+(Math.max(0,-hr.top)*0.10)+'px)'; } }
      if(statsEl&&statsVis&&statsSec){ var sr=statsSec.getBoundingClientRect(); var c=(sr.top+sr.height/2-innerH/2)/innerH; statsEl.style.transform='translateY('+(c*-26)+'px)'; }
      // Hero drawing is damped here rather than on the event, so it glides to a
      // stop after the cursor leaves instead of snapping back.
      if(bp&&heroLive){
        heroX=lerp(heroX,heroTX,.08); heroY=lerp(heroY,heroTY,.08);
        bp.style.transform='perspective(1200px) rotateY('+(heroX*9)+'deg) rotateX('+(-heroY*9)+'deg) translateZ(20px)';
      }
      if(tl&&tlVis){
        var tr=tl.getBoundingClientRect();
        var p2=clamp((innerH*0.82-tr.top)/(tr.height*0.9),0,1);
        tl.style.setProperty('--tl',p2.toFixed(3));
      }
    }
    if(pin&&sticky){
      var p=reduce?0:pinProgress();
      var n=stepsEl.length||1;
      var idx=Math.min(n-1,Math.floor(p*n));
      if(idx!==cur){ cur=idx; if(window.__setStage) window.__setStage(idx); else setStep(idx); }
      if(prog) prog.style.width=(p*100)+'%';
      if(seqCam&&seqImgs.length) drawSeq(p);
      if(pinReady){
        mOrbX=lerp(mOrbX,mTgtX,.06); mOrbY=lerp(mOrbY,mTgtY,.06);
        tTheta=-0.92 + p*1.95;          /* a 112 deg sweep across the front 3/4 — the bed stays readable, never turns its back */
        var mid=1-Math.abs(p-0.5)*2; tRadius=7.4 - mid*1.35 + Math.max(0,p-0.8)*4;   /* steps back on the last step so the room fits */
        tPhi=1.38 - p*0.10;             /* the eye drifts down a touch as the piece is finished */
        theta+=(tTheta-theta)*0.09; radius+=(tRadius-radius)*0.09;
        phi+=(tPhi-phi)*0.09;
        // The cursor adds to the scroll angle; it never replaces it.
        var savedT=theta, savedP=phi;
        theta+=mOrbX*0.42; phi-=mOrbY*0.20;
        if(pinVis){
          if(chairGrp&&!reduce) chairGrp.rotation.y=Math.sin((ts||0)*0.00035)*0.014;
          placePin(); renderer.render(scene,camera);
        }
        theta=savedT; phi=savedP;
      }
    }
  }
  requestAnimationFrame(frame);
})();

/* ---- the window this page actually gets -----------------------------------
   Two things shrink it. The theme's header is sticky and sits on top of the
   pinned panel, and the theme sets zoom:1.1 on <body>.

   The zoom is the awkward one: vh units ignore it, but getBoundingClientRect
   reports zoomed pixels, so "100vh" laid out 10% taller than the window while a
   measured header height came back 10% too large. The panel ended up 807px of
   screen for 734px of room, and its caption and pointer hint sat below the fold.

   So nothing here is left in vh. The zoom factor is recovered by comparing a
   real element's painted width with its layout width — that works wherever the
   zoom is declared — and both the header height and the viewport are written out
   in this page's own pixels for the CSS to subtract. */
(function(){
  var page=document.querySelector('.kf-page');
  var hdr=document.querySelector('#shopify-section-site-header')||document.querySelector('.site-header');
  if(!page) return;
  function set(){
    var ow=page.offsetWidth||0;
    var z=ow?(page.getBoundingClientRect().width/ow):1;
    if(!z||!isFinite(z)||z<=0) z=1;
    var h=hdr?Math.round(hdr.getBoundingClientRect().height/z):0;
    page.style.setProperty('--kf-hdr', Math.min(Math.max(h,0),240)+'px');
    page.style.setProperty('--kf-vh', Math.round(window.innerHeight/z)+'px');
  }
  set();
  window.addEventListener('resize',set);
  window.addEventListener('orientationchange',set);
  window.addEventListener('load',set);
})();

/* ---- showroom picker -> the live map --------------------------------------
   Same behaviour as the contact page: the whole card switches the map, and the
   two real links inside it (Directions, View showroom page) still do their own
   job, so a click on a link is never swallowed by the card. */
(function(){
  var frame=document.getElementById('kfmap');
  var where=document.getElementById('kfmapwhere');
  var open=document.getElementById('kfmapopen');
  var rows=[].slice.call(document.querySelectorAll('.show[data-q]'));
  if(!frame||!rows.length) return;

  function pick(row){
    var q=row.getAttribute('data-q'); if(!q) return;
    frame.src='https://www.google.com/maps?q='+encodeURIComponent(q)+'&output=embed';
    if(open) open.href='https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(q);
    if(where){
      var city=row.querySelector('.city'), area=row.querySelector('.area');
      where.textContent=(city?city.textContent.trim():'')+(area?' · '+area.textContent.trim():'');
    }
    rows.forEach(function(r){
      r.classList.toggle('is-active', r===row);
      r.setAttribute('aria-pressed', r===row?'true':'false');
    });
  }

  rows.forEach(function(row,i){
    row.addEventListener('click',function(e){ if(e.target.closest('a')) return; pick(row); });
    row.addEventListener('keydown',function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(row); }
    });
    if(i===0){ row.classList.add('is-active'); row.setAttribute('aria-pressed','true'); }
  });
})();
